import React, { createContext, useContext, useState, useMemo } from 'react';
import { INITIAL_SORT_CONFIG } from './initialState';

const SortContext = createContext();

export const SortProvider = ({ children }) => {
  const [sortConfig, setSortConfig] = useState(INITIAL_SORT_CONFIG);

  const resetSortState = () => {
    setSortConfig(INITIAL_SORT_CONFIG);
  };

  return (
    <SortContext.Provider value={useMemo(() => ({ sortConfig, setSortConfig, resetSortState }), [sortConfig])}>
      {children}
    </SortContext.Provider>
  );
};

export const useSortContext = () => useContext(SortContext);
